import { NgForOf } from '@angular/common';
import { Component, ElementRef, EventEmitter, Host, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Entities } from '../../../../data-rules-model';
import { ICustomPositioningConfig } from '../../../custom-component-overlay.directive';
import { IEntityItem } from '../../paired-autocomplete.component';
import { EntityItemComponent } from './entity-item/entity-item.component';

@Component({
  selector: 'app-entity-select',
  templateUrl: './entity-select.component.html',
  styleUrls: ['./entity-select.component.scss'],
  imports: [
    EntityItemComponent,
    NgForOf
  ]
})
export class EntitySelectComponent implements OnInit {
  @ViewChild(TemplateRef) templateRef: TemplateRef<any>;
  @Output() closed = new EventEmitter<void>();

  @Host() nativeElement: ElementRef<EntitySelectComponent>;

  @Input() onToggle: EventEmitter<boolean>;
  @Input() descriptorControl: FormControl;
  @Input() entities: IEntityItem[];
  @Input() primaryEntity: Entities;
  @Input() entitySelectorsMap: IEntityItem[];
  @Input() isSelected: (entity: IEntityItem) => boolean;
  @Input() renderIcon: (entity: string) => string;
  @Input() overlayPositioningConfig: ICustomPositioningConfig;

  constructor() {
  }

  ngOnInit() {
    this.closed.subscribe(() => {
      this.onToggle.emit(false);
    });
  }

}
